import { Component } from '@angular/core';

@Component({
  selector: 'DCO-startup',
  templateUrl: './startup.component.html',
  standalone: false,
})
export class StartupComponent {

}
